'use client';

import React, { useMemo, useRef, useState } from 'react';
import { useWindowScroll } from '@uidotdev/usehooks';
import classNames from 'classnames';
import { Button } from '@/features/button';
import { IconArrowSquareDown, IconArrowSquareLeft, IconArrowSquareUp } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import SafeHtml from '@/components/safe-html';
import { SHOW_MORE_BUTTON_CHARACTER_LIMIT } from '@/app/(pdp)/constants';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { cn } from '@/utils/cn';
import usePDPData from '../../_utils/use-pdp-data';
interface Props {
  openShowMoreModal: () => void;
}
function Description({
  openShowMoreModal
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = usePDPData();
  const description = data?.descriptionHtmlFa || '';
  const [isShowFullContent, setIsShowFullContent] = useState(PUBLIC_IS_BOT ?? false);
  const isTextOverflow = useMemo(() => description.length >= SHOW_MORE_BUTTON_CHARACTER_LIMIT, [description]);
  const scrollToElement = useRef(null);
  const [, scrollTo] = useWindowScroll();
  const offsetToTop = isMobile ? 552 : 230;
  const handleClick = () => {
    if (isMobile) {
      openShowMoreModal();
      return;
    }
    setIsShowFullContent(!isShowFullContent);
    if (isShowFullContent) scrollTo({
      top: offsetToTop,
      behavior: 'smooth'
    });
  };
  const ShowMoreButtonIcon = useMemo(() => {
    if (isMobile) return IconArrowSquareLeft;
    if (isShowFullContent) return IconArrowSquareUp;
    return IconArrowSquareDown;
  }, [isMobile, isShowFullContent]);
  const showMoreButtonText = useMemo(() => {
    if (isMobile) return 'مشاهده توضیحات بیشتر';
    if (isShowFullContent) return 'مشاهده کمتر';
    return 'مشاهده بیشتر';
  }, [isMobile, isShowFullContent]);
  if (!description) return null;
  return <div className='mt-3 inline-flex flex-col items-center gap-2 overflow-hidden text-justify lg:items-end lg:gap-3 lg:rounded lg:border lg:border-border-gray-light lg:px-2 lg:py-3' ref={scrollToElement} data-sentry-component="Description" data-sentry-source-file="description.tsx">
            <div data-test='pdp-description' className='relative flex w-full flex-col gap-2 lg:gap-3'>
                <h2 className='text-right text-body-14 font-bold text-text-black lg:text-body-16'>درباره محصول</h2>
                <SafeHtml content={description} className={classNames('pdp-content', !isShowFullContent && isTextOverflow ? 'line-clamp-4 text-ellipsis lg:max-h-30' : 'pb-3 lg:pb-0')} data-sentry-element="SafeHtml" data-sentry-source-file="description.tsx" />

                {!isShowFullContent && isTextOverflow && !isMobile && <div className='absolute bottom-0 right-0 h-3/4 w-full bg-gradient-to-t from-white' />}
            </div>
            <Button graphicStyle={isMobile ? 'subtle' : 'text'} size='small' onClick={() => handleClick()} icon={{
      element: <ShowMoreButtonIcon className='h-5 w-5 lg:h-6 lg:w-6' />,
      position: 'left'
    }} className={cn(!isTextOverflow ? 'hidden' : 'text-sm lg:-mt-3')} data-sentry-element="Button" data-sentry-source-file="description.tsx">
                {showMoreButtonText}
            </Button>
        </div>;
}
export default Description;